import { useMemo } from 'react';
import { useAppSelector } from '@/redux/hooks';
import { selectAllLanguagesMap } from '@/redux/selectors/constantsSelectors';
import { ScheduleAvailType } from '@/redux/slices/slice_types';
import { formatAvailDisplayLabel } from '@/components/Focus/utils/newScheduleAvails';

export const useFormatAvailDisplayLabel = () => {
  const allLanguagesMap = useAppSelector(selectAllLanguagesMap);
  const regionNamesInEnglish = useMemo(() => new Intl.DisplayNames(['en'], { type: 'region' }), []);

  return useMemo(
    () => (code: string, type: ScheduleAvailType) => formatAvailDisplayLabel(code, type, regionNamesInEnglish, allLanguagesMap),
    [allLanguagesMap, regionNamesInEnglish]
  );
};
